import { ActionTypes } from 'utils/constants';

export const resumeSubscription = (state = {}, action) => {
    switch(action.type) {
        case ActionTypes.RESUME_SUBSCRIPTION + '_PENDING': {
            return {
                ...state,
                processing: true
            };
        }
        case ActionTypes.RESUME_SUBSCRIPTION + '_REJECTED': {
            return {
                ...state,
                processing: false,
                error: true
            };
        }
        case ActionTypes.RESUME_SUBSCRIPTION + '_FULFILLED': {
            return {
                ...state,
                processing: false
            };
        }
        default: {
            return state;
        }
    }
};
